import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Home from '../components/Home.vue';
import CheckIn from "@/components/auth/CheckIn";
import SignIn from "@/components/auth/SignIn";
import SignupSuccess from "@/components/auth/SignupSuccess";
import CheckInSuccess from "@/components/auth/CheckInSuccess";
import ForgotPassword from "@/components/auth/ForgotPassword";
import PageNotFound from "@/components/PageNotFound";
import Users from "@/components/Users";
import Settings from "@/components/Settings";
import RestaurantsLayout from "@/components/restaurants/RestaurantsLayout";
import Restaurants from "@/components/restaurants/Restaurants";
import RestaurantCreate from "@/components/restaurants/RestaurantCreate";
import Restaurant from "@/components/restaurant_item/Restaurant";
import RestMenu from "@/components/restaurant_item/RestMenu";
import RestCategories from "@/components/restaurant_item/RestCategories";
import RestModifiers from "@/components/modifiers/Modifiers";
import RestModifiersOption from "@/components/modifiers/ModifiersOption";
import RestSettings from "@/components/restaurant_item/RestSettings";
import RestAddProduct from "@/components/restaurant_item/RestAddProduct";
import RestOrdersLayout from "@/components/restaurant_item/RestOrdersLayout";
import RestOrders from "@/components/restaurant_item/RestOrders";
import RestOrdersItem from "@/components/restaurant_item/RestOrdersItem";
import Statistics from "@/components/statistics/Statistics";
import i18n from "@/i18n";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { auth: true, breadcrumb: i18n.global.t('nav.home') },
  },
  {
    path: '/checkin',
    name: 'CheckIn',
    component: CheckIn,
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/signupsuccess',
    name: 'SignupSuccess',
    component: SignupSuccess
  },
  {
    path: '/checkinsuccess',
    name: 'CheckInSuccess',
    component: CheckInSuccess
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../components/Users'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.users') },
  },
  {
    path: '/couriers',
    name: 'Couriers',
    component: () => import('../components/Couriers'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.couriers') },
  },
  {
    path: '/integration',
    name: 'Integration',
    component: () => import('../components/Integration'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.integration') },
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../components/Reports'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.reports') },
  },
  {
    path: '/rate',
    name: 'Rate',
    component: () => import('../components/Rate'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.rate') },
  },
  {
    path: '/delivery-zones',
    name: 'DeliveryZones',
    component: () => import('../components/delivery_zones/DeliveryZones'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.deliveryZones') },
  },
  {
    path: '/map-create',
    name: 'MapCreate',
    meta: { auth: true, breadcrumb: i18n.global.t('nav.mapCreate') },
    component: () => import('../components/delivery_zones/MapCreate'),
  },
  {
    path: '/restaurants',
    name: 'RestaurantsLayout',
    component: () => import('../components/restaurants/RestaurantsLayout'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.restaurants') },
    props: true,
    children: [
      {
        path: '',
        name: 'Restaurants',
        meta: { auth: true },
        component: () => import('../components/restaurants/Restaurants'),
      },
      {
        path: ':id',
        name: 'Restaurant',
        component: () => import('../components/restaurant_item/Restaurant'),
        props: true,
        meta: { auth: true },
        children: [
          {
            path: '',
            name: "RestMenu",
            meta: { auth: true },
            component: () => import('../components/restaurant_item/RestMenu'),
          },
          {
            path: ":prodId",
            name: "RestMenuItem",
            meta: { auth: true },
            component: () => import('../components/restaurant_item/RestMenuItem'),
          },
          {
            path: "categories",
            name: "RestCategories",
            component: () => import('../components/restaurant_item/RestCategories'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.categories') },
          },
          {
            path: "modifiers",
            name: "RestModifiers",
            component: () => import('../components/modifiers/Modifiers'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.modifiers') },
          },
          {
            path: "option-for-modifiers",
            name: "ModifiersOption",
            component: () => import('../components/modifiers/ModifiersOption'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.modifiersOptions') },
          },
          {
            path: "orders",
            name: "RestOrdersLayout",
            component: () => import('../components/restaurant_item/RestOrdersLayout'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.orders') },
            children: [
              {
                path: "",
                name: "RestOrders",
                component: () => import('../components/restaurant_item/RestOrders'),
                meta: { auth: true },
              },
              {
                path: ":orderId",
                name: "RestOrdersItem",
                component: () => import('../components/restaurant_item/RestOrdersItem'),
                meta: { auth: true },
              },
            ]
          },

          {
            path: "settings",
            name: "RestSettings",
            component: () => import('../components/restaurant_item/RestSettings'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.settings') },
          },
          {
            path: "add-product",
            name: "RestAddProduct",
            component: () => import('../components/restaurant_item/RestAddProduct'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.productAdd') }
          },
          {
            path: "modules",
            name: "ModulesLayout",
            component: () => import('../components/restaurant_modules/ModulesLayout'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.modules') }
          },
          {
            path: "deploy",
            name: "RestDeploy",
            component: () => import('../components/deploy/DeployLayout'),
            meta: { auth: true, breadcrumb: i18n.global.t('navRest.deploy') },
          },
        ],
      },
    ]
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('../components/statistics/Statistics'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.statistics') },
  },
  {
    path: '/restaurant-create',
    name: 'RestaurantCreate',
    component: () => import('../components/restaurants/RestaurantCreate'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.restaurantAdd')  },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../components/Settings'),
    meta: { auth: true, breadcrumb: i18n.global.t('nav.settings')  },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import('../components/PageNotFound')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//проверка на авторизацию
router.beforeEach((to, from, next) => {
  const currentUser = store.getters.AUTHENTICATED // достаем из vuex аторизацию пользователя
  const requireAuth = to.matched.some(record => record.meta.auth) //проверяем включена ли в маршрут обязательная авторизация
  // if (currentUser) {
  //   const idTokenIsTrue = store.dispatch('checkIdToken')
  //   idTokenIsTrue.then(() => {
  //
  //   })
  // }
  if (requireAuth && !currentUser) {
    next('/signin')
  } else {
    next()
  }
})

export default router
